import { render, staticRenderFns } from "./AdditionOfCPA.vue?vue&type=template&id=5e57685a"
import script from "./AdditionOfCPA.vue?vue&type=script&lang=js"
export * from "./AdditionOfCPA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports